module.exports = __webpack_public_path__ + "img/50f1.1c28cbb2.jpg";